import KeenSlider from 'keen-slider';

const animation = { duration: 10000, easing: (t) => t }

const slider = ({ el }) => {
   return new KeenSlider(el, {
      loop: true,
      breakpoints: {
         "(min-width: 640px)": {
            slides: { perView: 4 },
         },
         "(min-width: 1024px)": {
            slides: { perView: 4 }
         },
         "(min-width: 1280px)": {
            slides: { perView: 3 }
         },
         "(min-width: 1400px)": {
            slides: { perView: 4 }
         },
      },
      slides: {
         origin: "center",
         perView: 5,
         spacing: 10,
      },
      vertical: true,
      renderMode: "performance",
      drag: true,
      created(s) {
         s.moveToIdx(5, true, animation)
      },
      updated(s) {
         s.moveToIdx(s.track.details.abs + 5, true, animation)
      },
      animationEnded(s) {
         s.moveToIdx(s.track.details.abs + 5, true, animation)
      },
   });
}

export default slider;